<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        let companyId = payload.$session.get('user').companyUser.company._id;
        payload.newData.companyUser.company = companyId
        setTimeout(async function() {
        $('#spinner').modal('toggle');
        payload.newData.companyUser.company = companyId
        let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
        if (response && response.status==200){
            payload.data = response.result;
        } 
        $('#spinner').modal('toggle');
        }, 300);
        console.log(payload.newData.companyUser.company)
    },
    methods:{
        changePassword: function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            state.data.password = state.newPassword;
            console.log(state.data)
            if(state.data){
                $('#spinner').modal('toggle');
                 Request.do(state,'PUT', Request.getDefaultHeader(state), state.data, `${Endpoints.systemUsers.systemUser}${state.data.email}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle'); 
                    this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.listUser.register.title.success'), this.$t('string.msg.listUser.register.message.success'), 'top left', 0, 630, 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.listUser.register.message.success')),
                            destroyed: this.clearText()
                        }) 
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }
        },
        changeEmail: function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            console.log(state.data)
            if(state.data){
                $('#spinner').modal('toggle');
                 Request.do(state,'PUT', Request.getDefaultHeader(state), {email: state.newEmail}, `${Endpoints.systemUsers.changeEmail}${state.data.email}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.flashMessage.success(
                            this.configMessage(this.$t('string.msg.listUser.register.title.success'), this.$t('string.msg.listUser.register.message.success'), 'top left', 0, 630, 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.listUser.register.message.success')),
                            destroyed: this.clearText()
                        }) 
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }
        },
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            this.newData.company = state.data.companyUser.company._id;
            
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.newData, `${Endpoints.systemUsers.systemUser}`,
                (userResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    location.reload();
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                            this.flashMessage.success(
                                this.configMessage(this.$t('string.msg.listUser.register.title.success'), this.$t('string.msg.listUser.register.message.success'), 'top left', 0, 630, 3000),
                            {
                            mounted: this.showText(this.$t('string.msg.listUser.register.message.success')),
                            destroyed: this.clearText()
                            }) 
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        checkForm2: function (e) {
            this.errors = [];
            if (!this.data.firstName) {
                this.errors.push(this.$t('response.user.register.firstname.required'));
            }
            if (!this.data.lastName) {
                this.errors.push(this.$t('response.user.register.lastname.required'));
            }
            if (!this.data.email) {
                this.errors.push(this.$t('response.user.register.email.required'));
            }
            if (!this.newPassword) {
                this.errors.push(this.$t('response.user.register.password.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.changePassword();
            }
        },
         checkForm3: function (e) {
            this.errors = [];
            if (!this.data.firstName) {
                this.errors.push(this.$t('response.user.register.firstname.required'));
            }
            if (!this.data.lastName) {
                this.errors.push(this.$t('response.user.register.lastname.required'));
            }
            if (!this.data.email) {
                this.errors.push(this.$t('response.user.register.email.required'));
            }
            if (!this.newEmail) {
                this.errors.push(this.$t('response.user.register.email.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.changeEmail();
            }
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.newData.firstName) {
                this.errors.push(this.$t('response.user.register.firstname.required'));
            }
            if (!this.newData.lastName) {
                this.errors.push(this.$t('response.user.register.lastname.required'));
            }
            if (!this.newData.email) {
                this.errors.push(this.$t('response.user.register.email.required'));
            }
            if (!this.newData.password) {
                this.errors.push(this.$t('response.user.register.password.required'));
            }

            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        },
        addUser: function (e){
            this.formCrud = 'show';
        },
        findAllUser: function(){
        const state = this;
        state.filters.companyId = state.$session.get('user').companyUser.company._id;
        Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.systemUsers.companyUser}`,
        (userResponse)=>{//SUCCESS CALLBACK
        state.users = userResponse.results;
        },
        (error)=>{//ERROR CALLBACK

        }); 
        },
        cancelAdd: function (e){
            this.formCrud = null;
            this.newData.firstName = null;
            this.newData.lastName = null;
            this.newData.email = null;
            this.newData.password = null;
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
         configMessage :function(title, message, position, x, y, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: x,
                y: y,
                time: time
            }
            return config
        },
        toUpperCase: Common.toUpperCase,
    }
}
</script>
